import React from 'react';
import {
  matchPath,
  useLocation,
  useNavigate,
  useRoutes,
} from 'react-router-dom';
import { Box, Divider, List, Stack, Switch, Typography } from '@mui/material';
import useLocalStorage from 'use-local-storage';
import SideNavItem from './SideNavItem';

interface IProps {
  navConfig: TMenu[];
}

export default function SideNav({ navConfig, ...other }: IProps) {
  const { pathname } = useLocation();
  const [isApiProd, toggleApiProd] = useLocalStorage('isApiProd', true);
  const match = (path: string) =>
    path ? !!matchPath({ path, end: false }, pathname) : false;

  const navigate = useNavigate();
  const handleApiChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    toggleApiProd(event.target.checked);
    setTimeout(() => {
      navigate('/auth/login');
    }, 300);
  };

  return (
    <Box {...other}>
      <List disablePadding>
        {navConfig.map((item) => (
          <SideNavItem key={item.title} item={item} active={match} />
        ))}
        <Divider />
        <Box sx={{ marginTop: 4, marginLeft: 9 }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='subtitle2'>Dev</Typography>
            <Switch
              checked={isApiProd}
              onChange={handleApiChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography variant='subtitle2'>Prod</Typography>
          </Stack>
        </Box>
      </List>
    </Box>
  );
}
